import React, { useState, useEffect, useRef } from 'react';
import { Box, Grid, TextField, Button, FormControlLabel, Checkbox, Select, MenuItem, ListItemText } from '@mui/material';
import axios from '../../utils/fvAxios';
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { removeUserSession } from '../../utils/Token';


export default function EmployeeSelfRegistration() {
  const [name, setName] = useState('');
  const [lastname, setLastName] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [language, setLanguage] = useState('');
  const [checked, setChecked] = useState(false);

  const [nameError, setNameError] = useState('');

  const [lastnameError, setLastNameError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');

  const [AllLanguage, setAllLanguage] = React.useState([]);
  const [languageId, setLanguageId] = React.useState("");
  const [vendorName, setVendorName] = React.useState([]);
  const [selectedVendor, setVSelectedendorName] = React.useState('')
  const [Clientcodebforclientid, setClientclientcodeforclientid] = React.useState('')
  const [getlocations, setLocations] = React.useState([])
  const [selectedLoction, SetSelectedLoaction] = React.useState([])
  const [loader, Setloader] = React.useState(true);
  const [loader1, Setloader1] = React.useState(false)
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 50 * 5 + 8,
        width: 200,
      },
    },
  };
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const clientcode = params.get("clientcode");
  useEffect(() => {

    axios.get("Common/GetClientCoursesLanguages?clientCode="+clientcode
    ).then((res) => {
      if (res?.data?.responseCode === 100) {
        setAllLanguage(res?.data?.data)
        setLanguageId(res?.data?.data[0]?.value)
      }
      else {
        // setError(res.data.responseMessage);
      }
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      // setIsLoading(false);
    });

    axios.get("Common/GetClientVendorsByClientCode?clientCode=" + clientcode
    ).then((respe) => {
      if (respe?.data?.responseCode === 100) {
        setVendorName(respe?.data?.data)
        setVSelectedendorName(respe?.data?.data[0]?.id)
      }
      else {
        // setError(res.data.responseMessage);
      }
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      Setloader(false);
    });

  }, []);






  useEffect(() => {
    axios.get("Common/GetClientIdByClientCode?clientCode=" + clientcode
    ).then((respn) => {
      if (respn?.data?.responseCode === 100) {
        setClientclientcodeforclientid(respn?.data?.data)
      }
      else {
        // setError(res.data.responseMessage);
      }
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      // setIsLoading(false);
    });
    axios.get("Common/GetLocationsByVendorId?vendorId=" + selectedVendor + "&clientId=" + Clientcodebforclientid
    ).then((resp) => {
      if (resp?.data?.responseCode === 100) {
        setLocations(resp?.data?.data)
      }
      else {
        // setError(res.data.responseMessage);
      }
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      Setloader(false);
    });
  }, [selectedVendor, Clientcodebforclientid])
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const handleclose = () => {
    // removeUserSession();
    // window.location = "/";
    setName('');
    setNameError('');
    setLastName('');
    setLastNameError('');
    setEmail('');
    setEmailError('');
    setPassword('');
    setPasswordError('');
    setConfirmPassword('');
    setConfirmPasswordError('');
    SetSelectedLoaction([])
    setVSelectedendorName('')
  }
  const Exit = () => {
    removeUserSession();
    window.location = "/login";

  }

  const handleNameChange = (event) => {
    setName(event.target.value);
    setNameError('');
  };

  const handleLastNameChange = (event) => {
    setLastName(event.target.value);
    setLastNameError('');
  };

  const [input, setInput] = useState('');
  const [inputError, setInputError] = useState('');

  const handleInputChange = (event) => {
    setInput(event.target.value);
    setInputError('');
  };
  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    setPasswordError('');
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
    setConfirmPasswordError('');
  };

  const handleDocTypeChange = (event) => {
    SetSelectedLoaction(event.target.value);
  };

  const menuListRef = useRef(null);
  const handleMenuOpen = () => {
    scrollToTopOfOtions();
  };
  const scrollToTopOfOtions = () => {
    setTimeout(() => {
      if (menuListRef.current) {
        const children = menuListRef.current.children;
        if (children.length >= 2) {
          const secondLastOption = children[children.length - 2];
          if (secondLastOption) {
            secondLastOption.scrollTop = 0;
          }
        }
      }
    }, 5);
  };
  function validateEmail(email) {
    // Regular expression for basic email validation
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,20}$/;
    // Test the email against the regex
    return emailRegex.test(email);
  }
  const isValidInput = (input) => {
    // Regular expressions for email and phone number validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    // Check if input is either a valid email or a valid phone number
    if (emailRegex.test(input) || phoneRegex.test(input)) {
      return true;
    } else {
      return false;
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    let isValid = true;
    if (name.trim() === '') {
      setNameError('First name is required');
      isValid = false;
    }

    if (lastname.trim() === '') {
      setLastNameError('Last name is required');
      isValid = false;
    }
    if (languageId?.trim() === '') {
      setLastNameError('Last name is required');
      isValid = false;
    }


    if (!isValidInput(input)) {
      setInputError('Please enter a valid email address or phone number');
      return;
    }

    if (password.trim() === '') {
      setPasswordError('Password is required');
      isValid = false;
    }

    if (confirmPassword.trim() === '') {
      setConfirmPasswordError('Please confirm your password');
      isValid = false;
    } else if (password !== confirmPassword) {
      setConfirmPasswordError('Passwords do not match');
      isValid = false;
    }

    if (isValid && checked == true && selectedLoction?.length != 0 && (selectedVendor != -1) &&getlocations?.length != 0 ) {

      Setloader1(true);
   
      const location = {
        "firstName": name,
        "lastName": lastname,
        "mobileNumber": input,
        "password": confirmPassword,
        "vendorId": Number(selectedVendor),
        ...(vendorName.length > 1 ? {

          "locations": selectedLoction?.map(str => parseInt(str))
        } : {}),
        "clientCode": clientcode,

        "languageId": Number(languageId)
      };


      axios.post("Common/EmployeeSelfRegistration", location).then((res) => {
        if (res?.data?.responseMessage == "Success") {
          toast.success(res?.data?.data, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          handleclose()
          // REFRESH(REFREE);
          // Close();
          setTimeout(() => {
            Setloader1(false);
          }, 5000)
      
        } else {
          toast.error(res?.data?.data, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setTimeout(() => {
            Setloader1(false);
          }, 5000)
          // setTimeout(() => {
          //   setDis(false);
          // }, 5000)
          // SetOpen();
        }
      })
    } else {
      toast.error("Please fill out the mandatory fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    
    }
  };

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader ||loader1}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <p style={{color:"#0C8AEB",fontSize:"18px",fontWeight:500,cursor:"pointer"}} onClick={Exit}>{"<--Back to login"}</p>
      <Grid container spacing={2}>
        <Grid item xs={2} md={1}>
        </Grid>
        <Grid item xs={12} md={10}>
          <div style={{ padding: "10px" }}>
            <b className="mt-3" style={{ fontSize: "24px" }}>Employee Registration</b>

            <Box
              border={1}
              borderLeft={1}
              borderRight={1}
              borderColor="#e4e7ec"
              className="mt-3"
              sx={{ background: '#fff', padding: "20px" }}
            >

              <ToastContainer />
              <form onSubmit={handleSubmit}>
                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: '20px' }}>
                  {/* First Name */}
                  <Grid item xs={12} sm={6} md={6}>
                    <p style={{ color: '#3E4A62', fontSize: '20px', fontWeight: '500', marginBottom: 0 }}>First Name <span style={{ color: "red" }}>*</span></p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      fullWidth
                      name="firstName"
                      size="small"
                      value={name}
                      onChange={handleNameChange}
                      error={!!nameError}
                      helperText={nameError}
                    />
                  </Grid>

                  {/* Last Name */}
                  <Grid item xs={12} sm={6} md={6}>
                    <p style={{ color: '#3E4A62', fontSize: '20px', fontWeight: '500', marginBottom: 0 }}>Last Name <span style={{ color: "red" }}>*</span></p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      fullWidth
                      name="lastName"
                      size="small"
                      value={lastname}
                      onChange={handleLastNameChange}
                      error={!!lastnameError}
                      helperText={lastnameError}
                    />
                  </Grid>

                  {/* Email */}
                  <Grid item xs={12} sm={6} md={6}>
                    <p style={{ color: '#3E4A62', fontSize: '20px', fontWeight: '500', marginBottom: 0 }}>User ID (Email Address or Mobile no) <span style={{ color: "red" }}>*</span></p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                  <TextField
          fullWidth
          name="input"
          size="small"
          value={input}
          onChange={handleInputChange}
          error={!!inputError}
          helperText={inputError}
        />
                  </Grid>

                  {/* Password */}
                  <Grid item xs={12} sm={6} md={6}>
                    <p style={{ color: '#3E4A62', fontSize: '20px', fontWeight: '500', marginBottom: 0 }}>Password <span style={{ color: "red" }}>*</span></p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      fullWidth
                      type="password"
                      size="small"
                      value={password}
                      onChange={handlePasswordChange}
                      error={!!passwordError}
                      helperText={passwordError}
                    />
                  </Grid>

                  {/* Confirm Password */}
                  <Grid item xs={12} sm={6} md={6}>
                    <p style={{ color: '#3E4A62', fontSize: '20px', fontWeight: '500', marginBottom: 0 }}>Confirm Password <span style={{ color: "red" }}>*</span></p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      fullWidth
                      type="password"
                      size="small"
                      value={confirmPassword}
                      onChange={handleConfirmPasswordChange}
                      error={!!confirmPasswordError}
                      helperText={confirmPasswordError}
                    />
                  </Grid>
                  {/* language */}
                  <Grid item xs={12} sm={6} md={6}>
                    <p style={{ color: '#3E4A62', fontSize: '20px', fontWeight: '500', marginBottom: 0 }}>Language <span style={{ color: "red" }}>*</span></p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <Select
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                        width: "100%"
                      }}
                      labelId="demo-multiple-name-label"
                      value={languageId || ""}
                      id="demo-multiple-name"
                      size="small"
                      onChange={(e) => setLanguageId(e.target.value)}
                      MenuProps={MenuProps}
                    >
                      {AllLanguage?.map((r, i) =>
                        <MenuItem key={i} value={r?.value}>{r?.key}</MenuItem>
                      )}
                    </Select>
                  </Grid>
                  {/* Vendor name */}
                  <Grid item xs={12} sm={6} md={6}
                  //  hidden={vendorName.length >= 1}
                  >
                    <p style={{ color: '#3E4A62', fontSize: '20px', fontWeight: '500', marginBottom: 0 }}> Vendor name <span style={{ color: "red" }}>*</span></p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <Select
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                        width: "100%"
                      }}
                      // hidden={vendorName.length >= 1}
                      labelId="demo-multiple-name-label"
                      value={selectedVendor || ""}
                      id="demo-multiple-name"
                      size="small"
                      onChange={(e) => (setVSelectedendorName(e.target.value), Setloader(true))}
                      MenuProps={MenuProps}
                    >
                      {vendorName?.map((r, i) =>
                        <MenuItem key={i} value={r?.id}>{r?.name}</MenuItem>
                      )}
                    </Select>
                  </Grid>
                  {/* location */}
                  <Grid item xs={12} sm={6} md={6}
                  //  hidden={vendorName.length >= 1}
                  >
                    <p style={{ color: '#3E4A62', fontSize: '20px', fontWeight: '500', marginBottom: 0 }}>Locations <span style={{ color: "red" }}>*</span></p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    {/* <Select
              sx={{
                '& legend': { display: 'none' },
                '& fieldset': { top: 0 },
                width: "100%"
              }}
              labelId="demo-multiple-name-label"
              value={selectedLoction || ""}
              id="demo-multiple-name"
              size="small"
              onChange={(e) => SetSelectedLoaction(e.target.value)}
              MenuProps={MenuProps}
            >
              {getlocations?.map((r, i) =>
                <MenuItem key={i} value={r?.value}>{r?.key}</MenuItem>
              )}
            </Select> */}
             

                    <Select
                      labelId="docs-label"
                      id="docs-select"
                      multiple
                      size='small'
                      // hidden={vendorName.length >= 1}
                      sx={{ width: "100%", overflow: "hidden" }}
                      name="doctypeList"
                      value={selectedLoction}
                      disabled={getlocations?.length > 0 ? false : true}
                      onChange={handleDocTypeChange}

                      MenuProps={{
                        ref: menuListRef,
                        PaperProps: MenuProps.PaperProps,
                      }
                      }
                      renderValue={(selected) =>
                        selected
                          // .map((value) => getlocations?.find((doc) => doc?.key === value)?.key)
                          .map((value) => getlocations?.find((doc) => doc?.value === value)?.key)
                          .filter((value) => value !== undefined)
                          .join(", ")
                      }
                      inputProps={{ 'aria-label': 'Select Documents' }}
                    >
                      <MenuItem key="Select All">

                        <Checkbox
                          id="select-all-checkbox"
                          indeterminate={
                            selectedLoction?.length > 0 && selectedLoction?.length < getlocations?.length
                          }
                          checked={selectedLoction?.length === getlocations?.length}
                          onChange={(event) => {
                            if (event?.target?.checked) {
                              SetSelectedLoaction(getlocations?.map((doc) => doc?.value));
                              scrollToTopOfOtions();
                            } else {
                              SetSelectedLoaction([]);
                            }
                          }}
                        />
                        <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                          Select All
                        </label>
                      </MenuItem>
                      {getlocations?.map((doc) => (
                        <MenuItem key={doc?.value} value={doc?.value} title={doc?.key}>
                          <Checkbox checked={selectedLoction?.indexOf(doc?.value) > -1} />
                          <ListItemText primary={doc?.key} sx={{ overflowX: "hidden" }} />
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  {/* Agreement */}



                </Grid>
                <br />
                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: '10px' }}>
                  <Grid item xs={12} sm={6} md={6}>
                    Please accept the  <a href="/terms_and_conditions" target="_blank" rel="noopener noreferrer">Terms and Conditions.</a> You must check the box below to confirm you agree to the Terms and Conditions:
                    <br />
                    <br />
                    <FormControlLabel
                      className='mx-1'
                      control={<Checkbox color="primary" name="agreement" checked={checked} onChange={handleChange} />}
                      label={<span><span className='mr-1' style={{ color: "red" }}>*</span>I agree to the <b>FIRST, VERIFY</b> Terms and Conditions.</span>}
                    />


                  </Grid>   </Grid>
                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ padding: '10px' }}> <Grid item xs={6} sm={6} md={6}>  <Button type="submit" variant="contained" color="primary" sx={{ padding: "10px" }}>
                  Create Account
                </Button> </Grid>
                  <Grid item xs={6} sm={6} md={6} sx={{ float: "right" }}>  <Button variant="contained" color="secondary" sx={{ padding: "10px", float: "right" }} onClick={handleclose}>Cancel</Button>  </Grid>    </Grid>

              </form>
            </Box>

          </div>
        </Grid>
        <Grid item xs={2} md={1}>
        </Grid> </Grid>
    </>
  );
}
